import React from 'react';
import { Reveal } from '../ui/Reveal';
import { facts, stats } from '../../data/highlights';
export function StatsSection() {
  return <section aria-labelledby="stats-heading" className="bg-brand-slate text-white" data-id="element-162" data-mp="3f0u17qgmsaak">
      <h2 id="stats-heading" className="sr-only" data-id="element-163" data-mp="303a2h1abvbcu">
        By the Numbers
      </h2>
      <div className="px-fluid py-section" data-id="element-164" data-mp="3524kw24duxwf">
        <dl className="grid gap-y-10 md:grid-cols-3" data-id="element-165" data-mp="3535z2fgp40id">
          {stats.map((stat, i) => <Reveal key={stat.label} delay={i * 0.05} className="md:border-l md:border-white/15 md:pl-[clamp(1.5rem,3vw,4rem)] md:first:border-l-0 md:first:pl-0" data-id="element-166" data-mp="3ssqtbuiauk6y" data-mpi={i}>
              <dt className="sr-only" data-id="element-167" data-mp="3nzxol6mtzbuv">{stat.label}</dt>
              <dd data-id="element-168" data-mp="3nymiv19tru14">
                <span className="block text-[clamp(2.75rem,1rem+4.6vw,8.5rem)] font-black leading-none tracking-[-0.03em] text-brand-accent" data-id="element-169" data-mp="3ny4iptk1kvnx">
                  {stat.value}
                </span>
                <span className="mt-4 block max-w-[20ch] text-[clamp(1rem,0.85rem+0.5vw,1.6rem)] font-semibold leading-snug text-white/90" data-id="element-170" data-mp="kc5h84udfazm">
                  {stat.label}
                </span>
              </dd>
            </Reveal>)}
        </dl>

        <div className="mt-[clamp(3.5rem,6vw,8rem)] grid gap-8 border-t border-white/15 pt-[clamp(2.5rem,4vw,5rem)] lg:grid-cols-12" data-id="element-171" data-mp="1e76xsp8g46mk">
          <Reveal className="lg:col-span-4" data-id="element-172" data-mp="19eni9mq771f4">
            <h3 className="text-h3 font-extrabold" data-id="element-173" data-mp="1n7da47ser0k5">Facts About David</h3>
          </Reveal>
          <ul className="grid gap-x-[clamp(1.5rem,3vw,4rem)] gap-y-6 md:grid-cols-3 lg:col-span-8" data-id="element-174" data-mp="1i8k573r6shvl">
            {facts.map((fact, i) => <Reveal as="li" key={fact} delay={i * 0.05} className="flex gap-4" data-id="element-175" data-mp="1x4rl3rvkax52" data-mpi={i}>
                <span aria-hidden="true" className="mt-[0.6em] h-2 w-2 shrink-0 rounded-full bg-brand-accent" data-id="element-176" data-mp="1s6gdlnsqoyq0" />
                <span className="text-body-fluid text-white/85" data-id="element-177" data-mp="2stdtvgtcbbt">{fact}</span>
              </Reveal>)}
          </ul>
        </div>
      </div>
    </section>;
}